import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-4 text-center">
      <p>© Todos os Direitos Reservados. | TSI Informática</p>
    </footer>
  );
};

export default Footer;
